module.exports = __webpack_public_path__ + "static/media/Avatars_Female-14.52da0c59.png";